import { render } from "./TheFooter.vue?vue&type=template&id=75fe7c02&scoped=true"
import script from "./TheFooter.vue?vue&type=script&lang=js"
export * from "./TheFooter.vue?vue&type=script&lang=js"

import "./TheFooter.vue?vue&type=style&index=0&id=75fe7c02&lang=scss&scoped=true"

import exportComponent from "C:\\agent\\_work\\860\\s\\ClientApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75fe7c02"]])

export default __exports__